import React from 'react';
import classNames from 'classnames';

import { Page, LayoutSingleColumn, OrderPanelSkeleton } from '../../components';
import FooterContainer from '../FooterContainer/FooterContainer';

import css from './ListingPage.module.css';

/**
 * Placeholder shown while the listing (and its data) are still loading.
 * Mirrors ListingPageCarousel's own two-column layout - gallery, title,
 * description on the left; OrderPanel on the right - so the page doesn't
 * jump once the real content arrives.
 *
 * @component
 * @param {Object} props
 * @param {React.Node} props.topbar
 * @param {boolean} props.scrollingDisabled
 * @param {import('../../util/reactIntl').intlShape} props.intl
 * @returns {JSX.Element}
 */
const ListingPageCarouselSkeleton = props => {
  const { topbar, scrollingDisabled, intl } = props;

  return (
    <Page
      title={intl.formatMessage({ id: 'ListingPage.loadingListingTitle' })}
      scrollingDisabled={scrollingDisabled}
    >
      <LayoutSingleColumn topbar={topbar} footer={<FooterContainer />}>
        <div className={css.contentWrapperForProductLayout}>
          <div className={css.skeletonMainColumn}>
            <div className={css.skeletonGallery} />
            <div className={css.skeletonTitle} />
            <div className={css.skeletonDescriptionLine} />
            <div className={css.skeletonDescriptionLine} />
            <div
              className={classNames(css.skeletonDescriptionLine, css.skeletonDescriptionLineShort)}
            />
          </div>
          <div className={css.skeletonOrderColumn}>
            <OrderPanelSkeleton />
          </div>
        </div>
      </LayoutSingleColumn>
    </Page>
  );
};

export default ListingPageCarouselSkeleton;
